import { Notice } from '@lbcamden/lib-react';

export interface InvalidMessageProps {
  invalidPropertyKind: string;
  isPcfra?: boolean;
}

export const InvalidPropertyMessage = ({ invalidPropertyKind, isPcfra }: InvalidMessageProps) => (
  <Notice
    css={(theme) => ({ maxHeight: 'fit-content', marginTop: theme.spacing(6) })}
    title="Invalid property"
    type="error"
  >
    {`You have selected a ${invalidPropertyKind} property. If you have been asked to conduct a
    ${isPcfra ? 'PCFRA for a resident at' : 'neighbourhood visit for'} this address, please report this message to the requestor.`}
  </Notice>
);
